import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { OperatorProvider } from '../../providers/operator/operator';
import { Operator, Meeting } from '../../models/models';
import { ApiProvider } from '../../providers/api/api';
import { SettingsProvider } from '../../providers/settings/settings';
import { MeetingPage } from '../meeting/meeting';
import { MainPage } from '../main/main';

@IonicPage()
@Component({
  selector: 'page-meetings-to-do-list',
  templateUrl: 'meetings-to-do-list.html',
})
export class MeetingsToDoListPage {
  operator: Operator
  isLoading: boolean

  planned_next = true
  planned_page = 0

  MEETING_PLANNED = 1
  MEETING_DONE = 2
  PRODUCT_MYP = this.settings.PRODUCT_MYP

  meetings_planned: Meeting[] = []

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private operatorProvider: OperatorProvider,
    private api: ApiProvider,
    public settings: SettingsProvider) {
    this.operatorProvider.currentOperator.subscribe(operator => {
      this.operator = operator
      this.refresh()
    })
  }

  ionViewDidEnter() {
    if (this.operator) {
      this.refresh(true)
    }
  }

  meetingStatus(meeting: Meeting) {
    switch (meeting.status) {
      case this.MEETING_PLANNED:
        return "Pianificato"
      case this.MEETING_DONE:
        return "Fatto"
      default:
        return "Annullato"
    }
  }

  nextPlanned(event, checkPage?) {
    this.isLoading = true
    if (!this.planned_next) {
      this.isLoading = false
      event.complete()
      return
    }
    this.planned_page++
    this.api.getPaginatedMeetings(this.operator.id, [this.MEETING_PLANNED], null, null, false, this.planned_page).subscribe(
      page => {
        this.meetings_planned.push(...page.results)
        this.meetings_planned = this.meetings_planned.filter(meeting_planned => {
          return new Date(meeting_planned.schedule_datetime) < new Date()
        })
        this.planned_next = page.next !== null
        this.apply_agenda_date(this.meetings_planned)
        this.isLoading = false
        if (checkPage && this.meetings_planned.length === 0) {
          this.navCtrl.push(MainPage)
        }
      },
      () => { },
      () => { if (event != null) event.complete() }
    )
  }

  apply_agenda_date(meetings: Meeting[]) {
    meetings.reduce((prev, current) => {
      let c_date: string = current.schedule_datetime.split("T")[0]
      current.show_date = prev == "" || prev != c_date
      return c_date
    }, "")
    return meetings
  }

  open(meeting: Meeting) {

    this.navCtrl.push(MeetingPage, {
      meeting: meeting,
      parent: this,
      operator: this.operator
    })

    // let meetingModal = this.modalCtrl.create(MeetingModalPage, {
    //   meeting: meeting,
    //   parent: this,
    //   operator: this.operator
    // }, { showBackdrop: true })
    // meetingModal.onDidDismiss(value => {
    // })
    // meetingModal.present()
  }

  reset() {
    this.planned_next = true
    this.meetings_planned = []
    this.planned_page = 0
  }

  refresh(checkPage?) {
    this.isLoading = true
    this.reset()

    this.nextPlanned(null, checkPage)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MeetingsToDoListPage');
  }

  goToMainPage() {
    this.navCtrl.push(MainPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/meetings-to-do-list/meetings-to-do-list.ts